import Pusher from 'pusher-js'
import toastification from '@/libs/toastification'
export default {
	initiatePusher( { rootGetters, commit } ) {
		let token = rootGetters['oauth/getToken']
		let pusher = new Pusher(process.env.VUE_APP_PUSHER_KEY, {
			cluster: process.env.VUE_APP_PUSHER_CLUSTER,
			forceTLS: false,
			authEndpoint: process.env.VUE_APP_API_HOST + '/broadcasting/auth',
			auth: {
			  headers: { "Authorization": "Bearer " + token },
			},
		});
		commit('setPusherInstance', pusher)
	},
	triggerNotif(_, payload) {
		if (payload.message.type === 'chat') {
			toastification.notif('You have new ' + payload.message.type, `You have new chat from ${payload.user.name}`, 'warning', 'MessageSquareIcon', 3000 )
		}
	}
}